import React from 'react';
import { CheckCircle2, Phone, Info } from 'lucide-react';
import { Button } from './ui/button';
import { PageHero } from './Sections';
import ContactForm from './ContactForm';
import { siteSettings as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';
import Seo from './Seo';
import { serviceLd, breadcrumbLd } from '../lib/seo';

const ServicePage = ({ data }) => {
  const { siteSettings = fb } = useContent();
  const path = data.path || (typeof window !== 'undefined' ? window.location.pathname : '');
  return (
    <div>
      <Seo
        title={`${data.title} in Cortez, CO & the Four Corners | ${siteSettings.companyFull || 'Comfort Air'}`}
        description={`${data.intro} Serving Cortez and Southwest Colorado since 1988. Call ${siteSettings.phone} for a free estimate.`.slice(0, 300)}
        image={data.image}
        jsonLd={[
          serviceLd(data.title, data.intro, path),
          breadcrumbLd([{ name: 'Home', path: '/' }, { name: data.title, path }])
        ]}
      />
      <PageHero title={data.title} subtitle={data.subtitle} crumb={data.title} />

      <section className="section-pad bg-white">
        <div className="container-c grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <img src={data.image} alt={data.title} className="rounded-2xl shadow-xl w-full h-80 object-cover" />
            <div className="mt-6 flex items-start gap-3 bg-brand-greenlight border border-brand-green/20 rounded-xl p-5">
              <Info className="text-brand-green shrink-0 mt-0.5" size={22} />
              <p className="text-slate-700 text-sm leading-relaxed">{data.note}</p>
            </div>
          </div>
          <div>
            <p className="text-xl text-brand-bluedark font-display font-semibold leading-snug">{data.intro}</p>
            {data.body.map((p, i) => (
              <p key={i} className="text-slate-600 leading-relaxed mt-4">{p}</p>
            ))}
            <a href={`tel:${siteSettings.phoneRaw}`} className="inline-block mt-6">
              <Button className="bg-brand-green hover:bg-brand-greendark text-white font-semibold h-12 px-7 gap-2">
                <Phone size={18} /> Call {siteSettings.phone}
              </Button>
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-bluelight">
        <div className="container-c">
          <h2 className="font-display font-extrabold text-2xl md:text-3xl text-brand-bluedark text-center">What We Offer</h2>
          <div className="h-1 w-20 bg-brand-green rounded-full mx-auto mt-4 mb-10" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {data.services.map((s) => (
              <div key={s} className="flex items-center gap-3 bg-white rounded-xl p-5 shadow-sm border border-slate-100 hover-lift">
                <CheckCircle2 className="text-brand-green shrink-0" size={22} />
                <span className="font-medium text-brand-bluedark">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-c max-w-3xl">
          <h2 className="font-display font-extrabold text-3xl text-brand-bluedark text-center">Request Service</h2>
          <p className="text-slate-600 text-center mt-3 mb-8">Fill out the form below and our team will get back to you shortly.</p>
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default ServicePage;
